import { useLocalStorage } from "@uidotdev/usehooks";

import { DropdownSelectItem } from "@/components/ui/Dropdown/DropdownSelect";

import timezonesJSON from "@/assets/timezones.json";

export function useTimezone() {
  const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const selectedTz = (timezonesJSON as DropdownSelectItem[]).find(
    (item) => item.key === browserTz,
  );

  const [tz, setTz] = useLocalStorage<Maybe<DropdownSelectItem>>(
    "tz",
    selectedTz,
  );

  return {
    tz: tz || timezonesJSON[0],
    setTz,
  };
}
